module.exports = __webpack_public_path__ + "img/AMD_LOGO.2f55b72c.jpg";